import { JSONSchemaType } from "ajv"
import validateConstant, {
  e入力パターン,
} from "../../../constant/validateConstant"
import util from "../../../ts/util"
import { TYosyaRegisterPostReq, TYosyaUpdatePutReq } from "./TYosya"

export const TYosyaRegisterPostReqSchema: JSONSchemaType<TYosyaRegisterPostReq> =
  {
    type: "object",
    properties: {
      傭車先コード: {
        minLength: 1,
        type: "string",
        maxLength: validateConstant.LENGTH.支払先コード,
        pattern: validateConstant.PATTERN.英数字のみ,
        title: "傭車先コード",
        errorMessage: util.stringErrorMessage("傭車先コード", {
          required: true,
          maxLength: validateConstant.LENGTH.支払先コード,
          pattern: e入力パターン.英数字のみ,
        }),
      },
      車番: {
        type: "string",
        minLength: 1,
        maxLength: validateConstant.LENGTH.車番,
        title: "車番",
        errorMessage: util.stringErrorMessage("車番", {
          required: true,
          maxLength: validateConstant.LENGTH.車番,
        }),
      },
      原動機有無フラグ: {
        type: "number",
        title: "原動機有無フラグ",
        enum: [0, 1],
        errorMessage: util.stringErrorMessage("原動機有無フラグ", {
          required: false,
        }),
      },
      車種区分コード: {
        type: "string",
        title: "車種区分コード",
        minLength: 1,
        maxLength: validateConstant.LENGTH.汎用区分コード,
        nullable: true,
        errorMessage: util.stringErrorMessage("車種区分コード", {
          required: true,
          maxLength: validateConstant.LENGTH.汎用区分コード,
        }),
      },

      乗務員名: {
        type: "string",
        maxLength: validateConstant.LENGTH.一般名称,
        title: "乗務員名",
        nullable: true,
        errorMessage: util.stringErrorMessage("乗務員名", {
          required: false,
          maxLength: validateConstant.LENGTH.一般名称,
        }),
      },
      備考: {
        type: "string",
        nullable: true,
        title: "備考",
        errorMessage: util.stringErrorMessage("備考", {
          required: true,
        }),
      },
    },
    required: ["傭車先コード", "車種区分コード", "車番"],
  }
export const TYosyaUpdatePutReqSchema: JSONSchemaType<TYosyaUpdatePutReq> = {
  type: "object",
  properties: {
    傭車先コード: {
      minLength: 1,
      type: "string",
      maxLength: validateConstant.LENGTH.支払先コード,
      pattern: validateConstant.PATTERN.英数字のみ,
      title: "傭車先コード",
      errorMessage: util.stringErrorMessage("傭車先コード", {
        required: true,
        maxLength: validateConstant.LENGTH.支払先コード,
        pattern: e入力パターン.英数字のみ,
      }),
    },
    車番: {
      type: "string",
      minLength: 1,
      maxLength: validateConstant.LENGTH.車番,
      title: "車番",
      errorMessage: util.stringErrorMessage("車番", {
        required: true,
        maxLength: validateConstant.LENGTH.車番,
      }),
    },
    原動機有無フラグ: {
      type: "number",
      title: "原動機有無フラグ",
      enum: [0, 1],
      errorMessage: util.stringErrorMessage("原動機有無フラグ", {
        required: false,
      }),
    },
    車種区分コード: {
      type: "string",
      title: "車種区分コード",
      minLength: 1,
      maxLength: validateConstant.LENGTH.汎用区分コード,
      nullable: true,
      errorMessage: util.stringErrorMessage("車種区分コード", {
        required: true,
        maxLength: validateConstant.LENGTH.汎用区分コード,
      }),
    },
    乗務員名: {
      type: "string",
      maxLength: validateConstant.LENGTH.一般名称,
      title: "乗務員名",
      nullable: true,
      errorMessage: util.stringErrorMessage("乗務員名", {
        required: false,
        maxLength: validateConstant.LENGTH.一般名称,
      }),
    },
    備考: {
      type: "string",
      nullable: true,
      title: "備考",
      errorMessage: util.stringErrorMessage("備考", {
        required: true,
      }),
    },
    更新日時: {
      type: "string",
      minLength: 1,
      title: "更新日時",
      errorMessage: util.stringErrorMessage("更新日時", {
        required: true,
      }),
    },
  },
  required: ["傭車先コード", "車種区分コード", "車番", "更新日時"],
  errorMessage: {
    required: util.JsonSchemeRequiredErrorMessages([
      "傭車先コード",
      "車番",
      "更新日時",
    ]),
  },
}
